import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Home.scss";
import Services from "pages/serviceslist/Services";
import { getBannerList } from "services/Bannerlist";
import { createCallbackList } from "services/contactus/contacthome";

import { getGalleryList } from "services/gallery/gallery";
import { FaHeart } from "react-icons/fa";
import { GalleryEvent } from "pages/gallery/GalleryPage";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";


const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [banners, setBanners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxSlides, setLightboxSlides] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    location: "",
    service: "",
  });


  // UI messages
  const [message, setMessage] = useState({ type: "", text: "" });
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [homeGalleryEvents, setHomeGalleryEvents] = useState([]);
  const [homeGalleryLoading, setHomeGalleryLoading] = useState(true);

  const openLightbox = (event, index) => {
    const slides = event.images.map((img) => ({
      src: img.url,
      title: event.title,
    }));
    setLightboxSlides(slides);
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  // Fetch banners
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await getBannerList();
        if (response?.code === 200) {
          setBanners(response.data?.banners || []);
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchBanners();
  }, []);

  useEffect(() => {
    const fetchHomeGallery = async () => {
      try {
        const res = await getGalleryList({ page: 1, limit: 10 });
        if (res?.code === 200 && res?.data?.galleries) {
          const formatted = res.data.galleries
            .map((event) => ({
              id: event.id,
              title: event.title || "Moments of Love & Care",
              date: event.addedon,
              images: event.images.map((img) => ({ url: img.url })),
            }))
            .slice(0, 2); // Sirf 2 events
          setHomeGalleryEvents(formatted);
        }
      } catch (err) {
        console.error("Home gallery fetch error:", err);
      } finally {
        setHomeGalleryLoading(false);
      }
    };
    fetchHomeGallery();
  }, []);

  // Prepare slides
  const slides = banners.map((banner, index) => {
    const imageUrl = banner.attachmentUrl
      ? banner.attachmentUrl.startsWith("http")
        ? banner.attachmentUrl
        : `http://192.168.1.57:7008/${banner.attachmentUrl}`
      : "https://via.placeholder.com/1920x1080";

    return {
      id: banner.BannerID || index,
      image: imageUrl,
      title: banner.BannerTitle || "Premium Service",
      subtitle: banner.Description || "High-quality home care services",
      number: String(index + 1).padStart(2, "0"),
    };
  });

  // Slider navigation
  const goToNext = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const goToPrev = () =>
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));

  // Auto-slide
  useEffect(() => {
    if (slides.length === 0) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [slides.length]);

  // Form handlers
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Mobile validation (only digits)
    if (name === "mobile") {
      const onlyNums = value.replace(/\D/g, "");
      if (onlyNums.length <= 10) {
        setFormData((prev) => ({ ...prev, mobile: onlyNums }));
      }
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // STRONG VALIDATION

    // Name
    if (!/^[a-zA-Z ]{3,}$/.test(formData.name.trim())) {
      return setMessage({ type: "error", text: "Enter a valid full name (min 3 letters)" });
    }

    // Only validate if user entered something
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(formData.email)) {
      return setMessage({ type: "error", text: "Enter a valid email address" });
    }

    // Mobile
    if (!/^[6-9]\d{9}$/.test(formData.mobile)) {
      return setMessage({ type: "error", text: "Enter a valid 10-digit mobile number" });
    }

    // Location
    if (formData.location.trim().length < 3) {
      return setMessage({ type: "error", text: "Enter a valid location" });
    }

    // Service Required
    if (formData.service.trim().length < 3) {
      return setMessage({ type: "error", text: "Enter a valid service name" });
    }

    setLoadingBtn(true);
    setMessage({ type: "", text: "" });

    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        location: formData.location,
        servicesrequired: formData.service,
      };

      const res = await createCallbackList(payload);

      if (res?.code === 200) {
        setMessage({ type: "success", text: "Request submitted successfully!" });
        setFormData({ name: "", email: "", mobile: "", location: "", service: "" });
      } else {
        setMessage({ type: "error", text: res?.message || "Failed to submit request." });
      }
    } catch (error) {
      setMessage({ type: "error", text: "Something went wrong. Try again." });
    } finally {
      setLoadingBtn(false);

      setTimeout(() => {
        setMessage({ type: "", text: "" });
      }, 3000);
    }
  };


  return (
    <>
      {/* HERO SLIDER + FORM */}
      <div className="lux-hero-wrapper">
        <div className="lux-hero-slider">
          {slides.length > 0
            ? slides.map((slide, index) => (
              <div
                key={slide.id}
                className={`lux-slide ${index === currentSlide ? "active" : ""}`}
              >
                <img
                  src={slide.image}
                  className="lux-bg"
                  alt={slide.title}
                // onError={(e) =>
                //   (e.target.src = "https://via.placeholder.com/1920x1080")
                // }
                />
                <div className="lux-overlay"></div>
                <div className="lux-content">
                  <h1>{slide.title}</h1>
                  <p>{slide.subtitle}</p>
                </div>
              </div>
            ))
            : (
              <div className="lux-slide active">
                <img
                  src="https://via.placeholder.com/1920x1080"
                  className="lux-bg"
                  alt="placeholder"
                />
                <div className="lux-overlay"></div>
                <div className="lux-content">
                  <h1>Premium Home Care</h1>
                  <p>Professional services for your loved ones</p>
                </div>
              </div>
            )}

          <button className="lux-nav left" onClick={goToPrev}>‹</button>
          <button className="lux-nav right" onClick={goToNext}>›</button>

          <div className="lux-dots">
            {slides.map((_, i) => (
              <span
                key={i}
                className={i === currentSlide ? "dot active" : "dot"}
                onClick={() => setCurrentSlide(i)}
              ></span>
            ))}
          </div>
        </div>

        {/* CALLBACK FORM */}
        <div className="hero-form">
          <h3>Request a Callback</h3>

          {/* UI MESSAGE */}
          {message.text && (
            <div
              className={`form-message ${message.type === "success" ? "success" : "error"
                }`}
            >
              {message.text}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}

            />

            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number"
              value={formData.mobile}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="location"
              placeholder="Location"
              value={formData.location}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="service"
              placeholder="Service Required"
              value={formData.service}
              onChange={handleChange}
              required
            />

            <button type="submit" className="callback-btn" disabled={loadingBtn}>
              {loadingBtn ? "Submitting..." : "Request Callback"}
            </button>
          </form>
        </div>
      </div>


      {/* SERVICES SECTION ON HOME PAGE - PERFECT LOOK */}
      <section className="home-services-section">
        <div className="services-preview-container">

          {/* Heading */}
          <div className="services-preview-title">
            <h2>Our Premium Services</h2>
            <p>Professional care delivered with love & trust at your doorstep</p>
          </div>

          {/* Services Grid - Sirf 3 cards, clean look */}
          <div className="home-services-grid">
            <Services
              limit={3}
              showHeader={false}
              showDescription={false}
              hideLoadMore={true}
            />
          </div>

          {/* Premium Button */}
          <div style={{ textAlign: "center", margin: "40px 0 20px" }}>
            <Link
              to="/services"
              style={{
                display: "inline-block",
                background: "linear-gradient(120deg, #001f3f, #005f99, #0099cc)",
                color: "white",
                padding: "14px 35px",
                borderRadius: "20px",
                fontSize: "1.1rem",
                fontWeight: "700",
                textDecoration: "none",
                // boxShadow: "0 12px 35px rgba(0, 31, 63, 0.4)",
                transition: "all 0.4s ease",
                position: "relative",
                overflow: "hidden",
                border: "none",
                cursor: "pointer",
                marginTop: "10px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                // e.currentTarget.style.boxShadow = "0 22px 50px rgba(0, 31, 63, 0.55)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                // e.currentTarget.style.boxShadow = "0 12px 35px rgba(0, 31, 63, 0.4)";
              }}
            >
              <span style={{ position: "relative", zIndex: 2 }}>
                View All Services
              </span>

              {/* Shining Effect */}
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  left: "-100%",
                  width: "60%",
                  height: "100%",
                  // background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)",
                  transform: "skewX(-20deg)",
                  transition: "left 0.7s ease",
                  pointerEvents: "none",
                }}
                onMouseEnter={(e) => e.currentTarget.style.left = "100%"}
                onMouseLeave={(e) => e.currentTarget.style.left = "-100%"}
              />
            </Link>
          </div>
        </div>
      </section>

      {/* HELPING PEOPLE SECTION */}
      <section className="recover-section">
        <h2>
          Helping People <span>Recover Fast</span> who
        </h2>

        <div className="recover-grid">
          <div className="recover-card"><span className="icon">♿</span><p>Lost the ability to walk</p></div>
          <div className="recover-card"><span className="icon">🥣</span><p>Have trouble eating or breathing</p></div>
          <div className="recover-card"><span className="icon">🧠</span><p>Have neurological disorders</p></div>
          <div className="recover-card"><span className="icon">➕</span><p>Have chronic illness</p></div>
        </div>
      </section>

      <section className="home-gallery-preview">
        <div className="gallery-preview-container">

          <div className="gallery-preview-title">
            <h2>Real Moments of Care & Recovery</h2>

          </div>

          <div className="gallery-preview-grid">
            {homeGalleryLoading ? (
              <div className="gallery-preview-empty">
                <p>Loading memories...</p>
              </div>
            ) : homeGalleryEvents.length === 0 ? (
              <div className="gallery-preview-empty">
                <FaHeart size={60} color="#ddd" />
                <p>Beautiful memories coming soon...</p>
              </div>
            ) : (
              homeGalleryEvents.map((event) => (
                <GalleryEvent    // YEH SAHI HAI!
                  key={event.id}
                  event={event}
                  openLightbox={openLightbox}  // Dummy function (click pe kuch nahi hoga)
                />
              ))
            )}
          </div>
          <div className="gallery-preview-btn-wrap">
            <Link
              to="/gallery"
              style={{
                display: "inline-block",
                background: "linear-gradient(120deg, #001f3f, #005f99, #0099cc)",
                color: "white",
                padding: "14px 35px",
                borderRadius: "20px",
                fontSize: "1.1rem",
                fontWeight: "700",
                textDecoration: "none",
                // boxShadow: "0 12px 35px rgba(0, 31, 63, 0.4)",
                transition: "all 0.4s ease",
                border: "none",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",

              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                // e.currentTarget.style.boxShadow = "0 20px 50px rgba(0, 31, 63, 0.55)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                // e.currentTarget.style.boxShadow = "0 12px 35px rgba(0, 31, 63, 0.4)";
              }}
            >
              <span style={{ position: "relative", zIndex: 2 }}>View All Gallery</span>

              {/* Shining effect */}
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  left: "-100%",
                  width: "50%",
                  height: "100%",
                  // background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
                  transform: "skewX(-4deg)",
                  transition: "left 0.6s ease",
                  pointerEvents: "none",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.left = "100%";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.left = "-100%";
                }}
              />
            </Link>
          </div>

        </div>
      </section>

      {/* MAP SECTION */}
      <section className="map-section">
        <div className="map-wrapper">

          {/* LEFT INFO */}
          <div className="map-info">
            <h2>Our Location</h2>

            <div className="info-item">
              <span className="icon">📍</span>
              <div>
                <h4>Address</h4>
                <p>
                  Sahyog Care Home and Medical Servises, Plot no 10/11, near B S Bane School,
                  Mhada, Vasant Vihar, old, Thane, Maharashtra 400610
                </p>
              </div>
            </div>

            <div className="info-item">
              <span className="icon">🕒</span>
              <div>
                <h4>Business Hours</h4>
                <p>Mon to Sun: Open 24 hours</p>
              </div>
            </div>

            {/* ⭐ New Item Added */}
            <div className="info-item">
              <span className="icon">✉️</span>
              <div>
                <h4>Email Support</h4>
                <p>care@sahyogcare.in</p>
              </div>
            </div>

            <div className="map-buttons">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=19.224255,72.9683915"
                target="_blank"
                rel="noreferrer"
                className="btn"
              >
                📍 Directions
              </a>

              <a href="tel:+918291008181" className="btn">
                ☎ Contact Us
              </a>
            </div>
          </div>


          {/* RIGHT MAP */}
          <div className="map-frame">
            <iframe
              title="Sahyog Care Home Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3311.133601877444!2d72.96581657452398!3d19.22426004730275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b960d8e6035b%3A0xfd47f43683a1d3ac!2sSahyog%20care%20home%20and%20health%20services%2C%20old%20age%20home%2C%20assisted%20living%2C%20bed%20ridden%20patient%20care!5e1!3m2!1sen!2sin!4v1764133919941!5m2!1sen!2sin"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>


        </div>
      </section>

      {lightboxOpen && (
        <Lightbox
          open={lightboxOpen}
          close={() => setLightboxOpen(false)}
          index={lightboxIndex}
          slides={lightboxSlides}
          plugins={[Thumbnails, Zoom]}
          thumbnails={{ width: 100, height: 70, gap: 12, borderRadius: 8 }}
        />
      )}

    </>
  );
};

export default Home;
